import {RestClient} from "zavadil-ts-common";
import {GenericResponsePayload} from "../../types/GenericResponsePayload";

export class ImportClient {

	client: RestClient;

	constructor(client: RestClient) {
		this.client = client;
	}

	import(file: File): Promise<GenericResponsePayload> {
		const formData = new FormData();
		formData.append("file", file);
		return this.client.postFormJson('import-contacts', formData);
	}

}
